import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const getDecks = async () => {
  const response = await axios.get(`${API_URL}/decks`, {
    withCredentials: true
  });
  return response.data;
};

export const getDeck = async (id) => {
  const response = await axios.get(`${API_URL}/decks/${id}`, {
    withCredentials: true
  });
  return response.data;
};

export const createDeck = async (formData) => {
  const response = await axios.post(`${API_URL}/decks`, formData, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateDeck = async (id, formData) => {
  try {
    //console.log('FormData envoyé:', Object.fromEntries(formData.entries())); // Pour déboguer
    const response = await axios.put(`${API_URL}/decks/${id}`, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erreur updateDeck:', error);
    throw error;
  }
};

export const deleteDeck = async (id) => {
  const response = await axios.delete(`${API_URL}/decks/${id}`, {
    withCredentials: true
  });
  return response.data;
};

export const updateCard = async (deckId, cardId, formData) => {
  try {
    const response = await axios.put(
      `${API_URL}/decks/${deckId}/cards/${cardId}`, 
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Erreur updateCard:', error);
    throw error;
  }
};

export const createCard = async (deckId, formData) => {
  try {
    const response = await axios.post(`${API_URL}/decks/${deckId}/cards`, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erreur createCard:', error);
    throw error;
  }
};

export const deleteCard = async (deckId, cardId) => {
  try {
    const response = await axios.delete(`${API_URL}/decks/${deckId}/cards/${cardId}`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Erreur deleteCard:', error);
    throw error;
  }
};

export const exportDeck = async (deckId) => {
  try {
    // D'abord récupérer les infos du deck pour avoir son nom
    const deckInfo = await getDeck(deckId);
    const sanitizedName = deckInfo.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_') // Remplace les caractères spéciaux par _
      .replace(/^_+|_+$/g, ''); // Enlève les _ au début et à la fin

    const response = await axios.get(`${API_URL}/decks/${deckId}/export`, {
      withCredentials: true,
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `deck_${sanitizedName}.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Erreur lors de l\'export:', error);
    throw error;
  }
}; 